//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const UserMigrationQueryUnion: FeatureFlag = {"Id":"UserMigrationQueryUnion","Label":"(KILL)[10.23]UserMigrationQueryUnion","Impact":"DON'T TOUCH UNLESS DIRECTED BY A DEVELOPER. Kill switch. Use Union instead of OR with Any() in user migration form query for better performance.","Mode":3,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":1};
